/**
 * Русские названия для значений перечислений движка.
 *
 * Живут отдельно, потому что нужны трём экранам сразу. Пока карта была одна —
 * на экране «Прогресс», — дублировать было нечего; с появлением формы своего
 * движения копий стало бы три, и первая же новая группа отобразилась бы
 * где-то как «forearms».
 *
 * Ключи — значения `MuscleGroup`, `Equipment` и `Mode` из `engine/types.py`.
 * Отсутствующий ключ показывается как есть: это честнее выдуманного перевода
 * и сразу видно, что клиент отстал от сервера.
 */

export const MUSCLE_RU: Record<string, string> = {
  chest: 'грудь',
  back: 'спина',
  shoulders: 'плечи',
  biceps: 'бицепс',
  triceps: 'трицепс',
  forearms: 'предплечья',
  quads: 'квадрицепс',
  hamstrings: 'бицепс бедра',
  glutes: 'ягодицы',
  calves: 'икры',
  abs: 'пресс',
}

export const EQUIPMENT_RU: Record<string, string> = {
  barbell: 'штанга',
  dumbbell: 'гантели',
  machine: 'тренажёр',
  cable: 'блок',
  bodyweight: 'свой вес',
}

/** Режим мезоцикла: от него зависит, как движок читает одни и те же цифры. */
export const MODE_RU: Record<string, string> = {
  deficit: 'дефицит',
  maintenance: 'поддержание',
  surplus: 'набор',
}

export function muscleLabel(group: string): string {
  return MUSCLE_RU[group] ?? group
}

export function modeLabel(mode: string): string {
  return MODE_RU[mode] ?? mode
}

export function equipmentLabel(kind: string): string {
  return EQUIPMENT_RU[kind] ?? kind
}
